var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.aclHelper.getSettingsUpdateAccess()
        ? _c("div", { staticClass: "row controls" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--darkblue",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.openAddBuildingModal()
                  },
                },
              },
              [_vm._v("\n      " + _vm._s(_vm.$t("action.add")) + "\n    ")]
            ),
            _vm._v(" "),
            _vm.editView
              ? _c(
                  "button",
                  {
                    directives: [{ name: "hkldreset", rawName: "v-hkldreset" }],
                    staticClass: "btn btn--darkblue",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.discardChange()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n      " + _vm._s(_vm.$t("action.cancel")) + "\n    "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.editView
              ? _c(
                  "button",
                  {
                    directives: [{ name: "hkldreset", rawName: "v-hkldreset" }],
                    staticClass: "btn btn--orange",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.save()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n      " + _vm._s(_vm.$t("action.save")) + "\n    "
                    ),
                  ]
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-wrapper", attrs: { id: "setting-buildings" } },
        [
          _c("table", { staticClass: "setting-table" }, [
            _c(
              "thead",
              [
                _c("th", [_vm._v(_vm._s(_vm.$t(_vm.itemHeaders[0].name)))]),
                _vm._v(" "),
                _vm._l(_vm.itemHeaders, function (header, index) {
                  return _c(
                    "th",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            Math.ceil(index / _vm.headerPageSize) ===
                            _vm.headerPageNum,
                          expression:
                            "Math.ceil(index/headerPageSize) === headerPageNum",
                        },
                      ],
                      key: index,
                      class: header.class,
                      on: {
                        click: function ($event) {
                          return _vm.navToDetail(header.id)
                        },
                      },
                    },
                    [
                      _c("a", [
                        _vm._v(
                          "\n            " +
                            _vm._s(header.name) +
                            " " +
                            _vm._s(
                              _vm.orderbyAttr === header.code
                                ? _vm.reverse
                                  ? "▼"
                                  : "▲"
                                : null
                            ) +
                            "\n            "
                        ),
                        header.code != "username"
                          ? _c("i", {
                              staticClass: "fa fa-external-link",
                              attrs: { "aria-hidden": "true" },
                            })
                          : _vm._e(),
                      ]),
                    ]
                  )
                }),
                _vm._v(" "),
                _c("th", { staticStyle: { "min-width": "120px" } }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn icon right",
                      attrs: {
                        type: "button",
                        disabled:
                          Math.ceil(
                            (_vm.itemHeaders.length - 1) / _vm.headerPageSize
                          ) <= _vm.headerPageNum,
                      },
                      on: {
                        click: function ($event) {
                          _vm.headerPageNum += 1
                        },
                      },
                    },
                    [_vm._v("▶")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn icon right",
                      attrs: {
                        type: "button",
                        disabled: _vm.headerPageNum <= 1,
                      },
                      on: {
                        click: function ($event) {
                          _vm.headerPageNum -= 1
                        },
                      },
                    },
                    [_vm._v("◀")]
                  ),
                ]),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "tbody",
              [
                _c("tr", [
                  _c("td", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.itemHeaders[0].filter,
                          expression: "itemHeaders[0].filter",
                        },
                      ],
                      attrs: { type: "text" },
                      domProps: { value: _vm.itemHeaders[0].filter },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.itemHeaders[0],
                              "filter",
                              $event.target.value
                            )
                          },
                          function ($event) {
                            return _vm.clearIndex()
                          },
                        ],
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("td", {
                    attrs: {
                      colspan:
                        _vm.headerPageNum === _vm.maxHeaderPageNum
                          ? ((_vm.itemHeaders.length - 1) %
                              _vm.headerPageSize) +
                            1
                          : _vm.headerPageSize + 1,
                    },
                  }),
                ]),
                _vm._v(" "),
                _vm._l(_vm.orderedItems, function (item) {
                  return _c(
                    "tr",
                    { key: item.id },
                    [
                      _c("td", [
                        _c(
                          "a",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.navToUserDetail(item.id)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.userName(item)))]
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.itemHeaders, function (header, index) {
                        return _c(
                          "td",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  index > 0 &&
                                  Math.ceil(index / _vm.headerPageSize) ===
                                    _vm.headerPageNum,
                                expression:
                                  "index > 0 && Math.ceil(index/headerPageSize) === headerPageNum",
                              },
                            ],
                            key: index,
                          },
                          [
                            _vm.editView || item.buildings[header.code]
                              ? _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: item.buildings[header.code],
                                      expression: "item.buildings[header.code]",
                                    },
                                    {
                                      name: "hkldinput",
                                      rawName: "v-hkldinput",
                                    },
                                  ],
                                  attrs: {
                                    id: "checkBox",
                                    type: "checkbox",
                                    disabled: !_vm.editView,
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      item.buildings[header.code]
                                    )
                                      ? _vm._i(
                                          item.buildings[header.code],
                                          null
                                        ) > -1
                                      : item.buildings[header.code],
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateUserBuilding(
                                        item.id,
                                        header.id,
                                        item.buildings[header.code]
                                      )
                                    },
                                    change: function ($event) {
                                      var $$a = item.buildings[header.code],
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              item.buildings,
                                              header.code,
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              item.buildings,
                                              header.code,
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(
                                          item.buildings,
                                          header.code,
                                          $$c
                                        )
                                      }
                                    },
                                  },
                                })
                              : _vm._e(),
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _c("td"),
                    ],
                    2
                  )
                }),
              ],
              2
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("AddBuildingModal", { ref: "addBuildingModal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }